export default {
  default: {
    light: {
      ui: {
        colors: {
          primary: "purple",
          neutral: "zinc",
        },
      },
    },
    dark: {
      ui: {
        colors: {
          primary: "purple",
          neutral: "zinc",
        },
      },
    },
  },
  commerzbank: {
    light: {
      ui: {
        colors: {
          primary: "commerzbank-dark",
          secondary: "commerzbank-neutral",
          warning: "commerzbank-gold",
          success: "commerzbank-mint",
          info: "commerzbank-mint",
        },
      },
    },
    dark: {
      ui: {
        colors: {
          primary: "commerzbank-gold",
          secondary: "commerzbank-gold",
          neutral: "commerzbank-neutral",
          success: "commerzbank-mint",
        },
      },
    },
  },
};
